import React from "react";
import { Box, useStyles } from "@chakra-ui/react";

const RequiredIndicator = () => {
  const styles = useStyles();

  return (
    <Box as="span" __css={styles.requiredIndicator}>
      *
    </Box>
  );
};

export default RequiredIndicator;
